import React, { CSSProperties } from "react";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import { AppState } from "../../pages/main.reducer";
import { Currency } from "../../common/constants";
import { convertPrice, getCurrencyLabel } from "../../common/currencyUtils";

export const NumberMoney: React.FC<{
  value: number;
  minValue?: number;
  style?: CSSProperties;
  forceCurrency?: Currency;
}> = ({ value, minValue, style, forceCurrency }) => {
  const storeCurrency = useSelector<AppState, Currency>(store => store.common.currency);
  const conversionRate = useSelector<AppState, number>(store => store.common.conversionRate);
  const currency = forceCurrency ?? storeCurrency;

  const convertedValue = convertPrice(value, currency, conversionRate);
  const convertedMinValue = minValue ? convertPrice(minValue, currency, conversionRate) : undefined;
  const label = getCurrencyLabel(currency);
  const decimals = currency === "KM" ? 2 : 0;

  return (
    <span style={{ whiteSpace: "nowrap", ...style }}>
      {convertedMinValue && convertedMinValue < convertedValue && (
        <>
          <NumberFormat
            value={convertedMinValue}
            displayType="text"
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={decimals}
            fixedDecimalScale={true}
          />
          {" - "}
        </>
      )}
      <NumberFormat
        value={convertedValue}
        displayType="text"
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={decimals}
        fixedDecimalScale={true}
      />
      &nbsp;<sup style={{ fontSize: "70%" }}>{label}</sup>
    </span>
  );
};

export const NumberDecimal: React.FC<{ value: number }> = ({ value }) => (
  <NumberFormat
    value={value}
    displayType="text"
    thousandSeparator="."
    decimalSeparator=","
    decimalScale={2}
    fixedDecimalScale={true}
  />
);
